import React from 'react';

type ButtonProps = {
  content: string;
  className?: string;
};

function Tooltip({ content, className }: ButtonProps) {
  return (
    <span
      data-after={content}
      className={`relative tooltip hover:after:block hover:before:block after:content-[attr(data-after)] ${className}`}
    />
  );
}

Tooltip.defaultProps = {
  className: '',
};

export default Tooltip;
